import { MODALS_ID } from '../constants'

import { modalStore } from '../provider/ModalProvider'

import { Alert } from '../components/alert'
import type { AlertProps } from '../components/alert/Alert'

/**
 * alert 띄우는 hook
 * @returns (props: AlertProps) => void
 */
export function useAlert() {
  const openAlert = (props: AlertProps) => {
    modalStore.openModal({ id: MODALS_ID.ALERT, Component: () => Alert(props) })
  }

  return openAlert
}
